import { render, staticRenderFns } from "./DownloadSpreadsheet.vue?vue&type=template&id=10c5c3ca&scoped=true&"
import script from "./DownloadSpreadsheet.vue?vue&type=script&lang=js&"
export * from "./DownloadSpreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSpreadsheet.vue?vue&type=style&index=0&id=10c5c3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5c3ca",
  null
  
)

export default component.exports